import { XCircleIcon } from "@phosphor-icons/react/dist/csr/XCircle";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Text } from "@volca/ui/components/ui/text";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { getErrorMessage } from "@/core/api/errors";
import { PayBreakdownPaneShell } from "@/payroll/pay-breakdown/pay-breakdown-pane-shell";
import {
  AMOUNT_COLUMN,
  LINES_COLUMN,
  SelectCol,
  TECHNICIAN_COLUMN,
} from "./cols";
import { StAdjustmentsPreviewHeader } from "./st-adjustments-preview-header";
import { StAdjustmentsRollupTable } from "./st-adjustments-rollup-table";
import { useStAdjustmentsSection } from "./st-adjustments-section";

const EMPTY_SELECTION = new Set<number>();
const noAction = () => {};
const PREVIEW_SELECT_COLUMN = SelectCol({
  disabled: true,
  selectedTechnicianIds: EMPTY_SELECTION,
  allPushableSelected: false,
  somePushableSelected: false,
  pushableCount: 0,
  onToggleAll: noAction,
  onToggle: noAction,
});
const PREVIEW_COLUMNS = [
  PREVIEW_SELECT_COLUMN,
  TECHNICIAN_COLUMN,
  AMOUNT_COLUMN,
  LINES_COLUMN,
];

export const StAdjustmentsPreview = () => {
  const { isLoading, summaryError, byTechnician } = useStAdjustmentsSection();
  return (
    <PayBreakdownPaneShell fillHeight gap={6} className="h-full opacity-75">
      {summaryError && !isLoading && (
        <Alert color="danger">
          <XCircleIcon />
          <AlertDescription>
            <Text>{getErrorMessage(summaryError)}</Text>
          </AlertDescription>
        </Alert>
      )}

      {isLoading && (
        <Spinner layout="centered" className="h-40" tone="primary" />
      )}

      {!isLoading && !summaryError && byTechnician.length === 0 && (
        <Empty className={emptyStateVariants({ layout: "inline" })}>
          <EmptyHeader>
            <EmptyDescription>
              No named technician users with valid ServiceTitan IDs were found
              for this business.
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      )}

      {!isLoading && !summaryError && byTechnician.length > 0 && (
        <StAdjustmentsRollupTable columns={PREVIEW_COLUMNS}>
          <StAdjustmentsPreviewHeader />
        </StAdjustmentsRollupTable>
      )}
    </PayBreakdownPaneShell>
  );
};
